import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0caed76e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload_con" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("重新上传")
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("上传音频")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload_help" }, "推荐mp3,wav,m4a格式", -1))
const _hoisted_9 = { key: 1 }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 0,
  style: {"margin-top":"10px"}
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("重新上传")
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("上传视频")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload_help" }, "推荐mp4,3gp,m3u8格式", -1))
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "ant-upload-text" }
const _hoisted_19 = { key: 3 }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "上传", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_loading_outlined = _resolveComponent("loading-outlined")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.uploadType === 'audio')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.sourceUrl)
            ? (_openBlock(), _createElementBlock("audio", {
                key: 0,
                src: _ctx.sourceUrl,
                controls: "",
                style: {"max-width":"500px"}
              }, "您的浏览器不支持 audio 标签。", 8, _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createVNode(_component_a_upload, {
              name: "file",
              class: "avatar-uploader",
              "before-upload": _ctx.beforeUploadAudio,
              headers: _ctx.uploadHeaders,
              action: _ctx.uploadAction,
              data: _ctx.uploadFormData,
              onChange: _ctx.handleChange,
              accept: "audio/*"
            }, {
              default: _withCtx(() => [
                (_ctx.sourceUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_a_button, {
                        type: "dashed",
                        danger: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_a_button, { type: "primary" }, {
                        default: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 1
                      })
                    ]))
              ]),
              _: 1
            }, 8, ["before-upload", "headers", "action", "data", "onChange"]),
            _hoisted_8
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.uploadType === 'video')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_ctx.sourceUrl)
            ? (_openBlock(), _createElementBlock("video", {
                key: 0,
                src: _ctx.sourceUrl,
                controls: "",
                style: {"max-width":"500px"}
              }, "您的浏览器不支持 video 标签。", 8, _hoisted_10))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createVNode(_component_a_upload, {
              name: "file",
              class: "avatar-uploader",
              "before-upload": _ctx.beforeUploadVideo,
              headers: _ctx.uploadHeaders,
              action: _ctx.uploadAction,
              data: _ctx.uploadFormData,
              onChange: _ctx.handleChange,
              accept: "video/*"
            }, {
              default: _withCtx(() => [
                (_ctx.sourceUrl)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_a_button, {
                        type: "dashed",
                        danger: ""
                      }, {
                        default: _withCtx(() => [
                          _hoisted_12
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_a_button, { type: "primary" }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      })
                    ]))
              ]),
              _: 1
            }, 8, ["before-upload", "headers", "action", "data", "onChange"]),
            _hoisted_15
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.uploadType === 'image')
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_component_a_upload, {
            name: "file",
            "file-list": _ctx.fileList,
            "list-type": "picture-card",
            class: "avatar-uploader",
            "before-upload": _ctx.beforeUploadImage,
            headers: _ctx.uploadHeaders,
            action: _ctx.uploadAction,
            data: _ctx.uploadFormData,
            onChange: _ctx.handleImageChange,
            accept: "image/*"
          }, {
            default: _withCtx(() => [
              (_ctx.fileList.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    (_ctx.loading)
                      ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                      : (_openBlock(), _createBlock(_component_plus_outlined, { key: 1 })),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.uploadText), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["file-list", "before-upload", "headers", "action", "data", "onChange"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.uploadType === 'file')
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(_component_a_upload, {
            name: "file",
            "file-list": _ctx.fileList,
            "list-type": "picture-card",
            class: "avatar-uploader",
            headers: _ctx.uploadHeaders,
            action: _ctx.uploadAction,
            data: _ctx.uploadFormData,
            onChange: _ctx.handleImageChange
          }, {
            default: _withCtx(() => [
              (_ctx.fileList.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    (_ctx.loading)
                      ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                      : (_openBlock(), _createBlock(_component_plus_outlined, { key: 1 })),
                    _hoisted_21
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["file-list", "headers", "action", "data", "onChange"])
        ]))
      : _createCommentVNode("", true)
  ]))
}